import React, { Component } from 'react';
import './NewPassword.css';
import Loading from './../../components/loading/Loading';
import services from './../../services/index'
import { Redirect } from 'react-router-dom';

export default class Newpassword extends Component {

  state = {
    loading: true,
    redirect: false,
    novaSenha: '',
    confirmaSenha: '',
    token: '',
    id: 0
  }

  async componentDidMount() {
    if (this.props.match.params.token) {
      const token = this.props.match.params.token;
      let response = await services.validaToken(token);

      if (response.id) {
        this.setState({ loading: false, token: token, id: response.id });
      } else {
        alert('Acesso não permitido');
        this.setState({ redirect: true });
      }
    }
  }


  handleAllInputs = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  atualizaSenha = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    try {
      if (this.state.novaSenha === this.state.confirmaSenha) {
        let response = services.atualizaSenha(this.state.id, this.state.novaSenha, this.state.token);
        if (!response.err) {
          alert('Senha alterada. Por favor faça login');
          this.setState({ redirect: true, loading: false });
        } else {
          alert('A senha não pode ser alterada');
          this.setState({ redirect: true, loading: false });
        }
      } else {
        this.setState({ loading: false });
        alert('Senhas não conferem');

      }
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });

    }

  }

  render() {

    if (this.state.redirect) {
      return <Redirect to={{ pathname: '/', state: { from: '/' } }} />
    }

    if (this.state.loading) {
      return <Loading />
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="content-recupera-senha">
                <form onSubmit={this.atualizaSenha} className="frmCadCli">
                  <div className="row">

                    <div className="col-md-5">
                      <div className="form-group">
                        <label>Nova Senha</label>
                        <input type="password" className="form-control yellowOutline" name="novaSenha" value={this.state.novaSenha} onChange={this.handleAllInputs} />
                      </div>
                    </div>

                    <div className="col-md-5">
                      <div className="form-group">
                        <label>Confirmar Nova Senha</label>
                        <input type="password" className="form-control yellowOutline" name="confirmaSenha" value={this.state.confirmaSenha} onChange={this.handleAllInputs} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">

                        <button type="submit" className="btn btn-primary  btnCadastrar">Atualizar Senha</button>
                      </div>
                    </div>

                  </div>


                </form>
              </div>
            </div>

          </div>
        </div>
      );
    }

  }
}
